import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityCurrentEmpresaState
} from './entity-current-empresa.state';
import { entityCurrentEmpresaAdapter } from './entity-current-empresa.state';
import {
  entityCurrentEmpresaLoadRequest,
  entityCurrentEmpresaLoadSuccess,
  entityCurrentEmpresaLoadFailure,
  entityCurrentEmpresaSetEmpty
} from './entity-current-empresa.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityCurrentEmpresaLoadRequest, (state) => ({
    ...initialState,
    isLoading: true,
    error: null
  })),
  on(entityCurrentEmpresaLoadFailure, (state, { error }) => ({
    ...initialState,
    isLoading: false,
    error: error
  })),
  on(entityCurrentEmpresaLoadSuccess, (state, { item }) =>
    entityCurrentEmpresaAdapter.addOne(item, {
      ...initialState,
      isLoading: false,
      error: null
    })
  ),
  on(entityCurrentEmpresaSetEmpty, (state, {}) =>
    entityCurrentEmpresaAdapter.removeAll({
      ...initialState,
      isLoading: false,
      error: null
    })
  )
);

export function currentEmpresaReducer(
  state: EntityCurrentEmpresaState | undefined,
  action: Action
) {
  return reducer(state, action);
}
